var getThemeValue = function getThemeValue(name, props, values) {
  var _props$theme;
  var value = (_props$theme = props.theme) === null || _props$theme === void 0 ? void 0 : _props$theme[name];
  var themeValue = values[value];
  if (typeof values === 'string') {
    return values;
  }
  return themeValue || Object.values(values)[0];
};
var siteThemes = {
  DEFAULT: 'DEFAULT',
  GLOBETROTTER: 'GLOBETROTTER'
};
var theme = function theme(name, values) {
  return function (props) {
    return getThemeValue(name, props, values);
  };
};
var themeWithVariant = function themeWithVariant(name, prop, values, fallback) {
  return function (props) {
    var variant = props[prop] && values[props[prop]];
    if (!variant) {
      return getThemeValue(name, props, fallback);
    }
    return getThemeValue(name, props, variant);
  };
};
var variant = function variant(name, values, fallback) {
  return function (props) {
    return values[props[name]] || fallback || values[0];
  };
};
var isGlobetrotter = function isGlobetrotter(styles) {
  return function (props) {
    return props.theme.site === siteThemes.GLOBETROTTER && styles;
  };
};
var isDefaultTheme = function isDefaultTheme(styles) {
  return function (props) {
    return props.theme.site === siteThemes.DEFAULT && styles;
  };
};

export { isDefaultTheme, isGlobetrotter, siteThemes, theme, themeWithVariant, variant };
//# sourceMappingURL=theming.js.map
